import { Box, Paper, Typography } from "@mui/material";

const AddNewDayCard = ({ numberOfDays, onAddNewDay }) => {
    return (
        <Paper
            elevation={2}
            sx={{
                minWidth: 220,
                height: 200,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#e3f2fd',
                borderRadius: 2,
                border: '2px dashed #2196f3',
                cursor: 'pointer',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                    backgroundColor: '#bbdefb',
                    transform: 'translateY(-2px)',
                    boxShadow: 4
                }
            }}
            onClick={onAddNewDay}
        >
            <Box
                sx={{
                    width: 60,
                    height: 60,
                    borderRadius: '50%',
                    backgroundColor: 'primary.main',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '30px',
                    marginBottom: 2,
                    transition: 'transform 0.2s ease-in-out',
                    '&:hover': {
                        transform: 'scale(1.1)'
                    }
                }}
            >
                +
            </Box>
            <Typography
                variant="h6"
                sx={{
                    color: 'primary.main',
                    fontWeight: 'bold',
                    textAlign: 'center'
                }}
            >
                הוסף אימון חדש
            </Typography>
            <Typography
                variant="body2"
                sx={{
                    color: 'primary.dark',
                    textAlign: 'center',
                    marginTop: 1
                }}
            >
                אימון {numberOfDays + 1}
            </Typography>
        </Paper>
    );
};

export default AddNewDayCard;